/**
 * @generated SignedSource<<d6d7592ec27584977783c62207035b56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type checkoutShippingActions_viewer$data = {
  readonly restrictionsEnabled: boolean | null;
  readonly " $fragmentType": "checkoutShippingActions_viewer";
};
export type checkoutShippingActions_viewer$key = {
  readonly " $data"?: checkoutShippingActions_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutShippingActions_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "checkoutShippingActions_viewer",
  "selections": [
    {
      "alias": "restrictionsEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "restrictedMaterials"
        }
      ],
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": "isEnabled(key:\"restrictedMaterials\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "4f381061860372ca3a88f9d8ff00b2cb";

export default node;
